var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {}, [
    _c("div", { staticStyle: { padding: "30px" } }, [
      _c(
        "div",
        {},
        [
          _c("div", {}, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "24px",
                  "font-family": "PingFang SC",
                  "font-weight": "bold",
                  color: "#343434"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_account_management")))]
            )
          ]),
          _vm._v(" "),
          _c("div", {}, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "18px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434",
                  "line-height": "51px"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_change_password")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      color: "#999999",
                      float: "left",
                      "line-height": "40px",
                      "margin-right": "40px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_old_password")))]
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { float: "left", width: "400px" },
                  attrs: {
                    placeholder: _vm.addPls("i18n_old_password", "input"),
                    clearable: "",
                    "show-password": ""
                  },
                  model: {
                    value: _vm.oldPwd,
                    callback: function($$v) {
                      _vm.oldPwd = $$v
                    },
                    expression: "oldPwd"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      color: "#999999",
                      float: "left",
                      "line-height": "40px",
                      "margin-right": "40px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_new_password")))]
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { float: "left", width: "400px" },
                  attrs: {
                    placeholder: _vm.addPls("i18n_new_password", "input"),
                    clearable: "",
                    "show-password": ""
                  },
                  model: {
                    value: _vm.newPwd,
                    callback: function($$v) {
                      _vm.newPwd = $$v
                    },
                    expression: "newPwd"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      color: "#999999",
                      float: "left",
                      "line-height": "40px",
                      "margin-right": "24px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_confirm_password")))]
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticStyle: { float: "left", width: "400px" },
                  attrs: {
                    placeholder: _vm.addPls("i18n_confirm_password", "input"),
                    clearable: "",
                    "show-password": ""
                  },
                  model: {
                    value: _vm.newPwdConfirm,
                    callback: function($$v) {
                      _vm.newPwdConfirm = $$v
                    },
                    expression: "newPwdConfirm"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submit } },
            [_vm._v(_vm._s(_vm.$t("i18n_confirm_edit")))]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {},
        [
          _c("div", { staticStyle: { height: "30px" } }),
          _vm._v(" "),
          _c("div", {}, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "18px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434",
                  "line-height": "51px"
                }
              },
              [_vm._v(_vm._s(_vm.$t("i18n_change_contact_number")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      color: "#999999",
                      float: "left",
                      "line-height": "40px",
                      "margin-right": "40px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_old_contact_number")))]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#333333",
                      "line-height": "40px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.phoneNo))]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      color: "#999999",
                      float: "left",
                      "line-height": "40px",
                      "margin-right": "56px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_new_contact_number")))]
                ),
                _vm._v(" "),
                _c(
                  "el-input",
                  {
                    staticStyle: { float: "left", width: "400px" },
                    attrs: { placeholder: _vm.$t("i18n_new_contact_number") },
                    model: {
                      value: _vm.newPhone,
                      callback: function($$v) {
                        _vm.newPhone = $$v
                      },
                      expression: "newPhone"
                    }
                  },
                  [_c("template", { slot: "prepend" }, [_vm._v("+86")])],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "block",
                staticStyle: { "margin-bottom": "20px" }
              },
              [
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-size": "16px",
                      "font-family": "PingFang SC",
                      "font-weight": "400",
                      color: "#999999",
                      float: "left",
                      "line-height": "40px",
                      "margin-right": "70px"
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("i18n_verification_code")))]
                ),
                _vm._v(" "),
                _c(
                  "el-input",
                  {
                    staticStyle: { float: "left", width: "400px" },
                    attrs: { placeholder: _vm.$t("i18n_verification_code") },
                    model: {
                      value: _vm.code,
                      callback: function($$v) {
                        _vm.code = $$v
                      },
                      expression: "code"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { slot: "append" },
                        on: { click: _vm.sendCode },
                        slot: "append"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.countDown > 0
                              ? _vm.countDown
                              : _vm.$t("i18n_Receive_SMS_verification_code")
                          )
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitPhone } },
            [_vm._v(_vm._s(_vm.$t("i18n_confirm_edit")))]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b920607", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b920607","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/accountManage/UserManage.vue
// module id = null
// module chunks = 